import generateAnonymousId from './generateAnonymousId';

export default generateAnonymousId;
